import { Pipe, PipeTransform } from '@angular/core';
import { CustomModel } from './formly-matrix-field.component';

@Pipe({
  name: 'filterMatrix',
})
export class FilterMatrixPipe implements PipeTransform {
  transform(
    items: CustomModel[],
    yKey: string,
    xKey: string,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    reload: boolean
  ) {
    if (yKey && xKey) {
      const key = `${yKey}|${xKey}`;
      return items.filter((x) => x.key === key)[0].selected;
    }
  }
}
